import React, { FC } from 'react';
import { Route } from 'react-router-dom';
import { RouteProps } from 'react-router';
// import { Helmet } from 'react-helmet';
import PrivateRoute from './privateRoute';
import { useIntl } from 'react-intl';
import { ErrorBoundary } from '@app/common';

export interface WrapperRouteProps extends RouteProps {
  /** document title locale id */
  titleId: string;
  /** authorization？ */
  auth?: boolean;
}

const WrapperRouteComponent: FC<WrapperRouteProps> = ({ titleId, auth, ...props }) => {
  const { formatMessage } = useIntl();
  const WitchRoute = auth ? PrivateRoute : Route;
  // <Helmet>
  //   <title>{formatMessage({ id: titleId })}</title>
  // </Helmet>
  if (titleId) {
    document.title = formatMessage({
      id: titleId
    });
  }
  return (
    <ErrorBoundary>
      <WitchRoute {...props} />
    </ErrorBoundary>
  );
};

export default WrapperRouteComponent;
